import SectionHeader from '@/components/feature/SectionHeader';
import MovieCard from '@/components/feature/MovieCard';
import { getFeaturedMovies } from '@/mocks/movies';

export default function FeaturedSection() {
  const featured = getFeaturedMovies();

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          title="精选推荐"
          subtitle="编辑团队精心挑选的高分佳作"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}